import { HISTORY_OPERATION_TYPE } from "@letsbit/malcolmlb";
import { defineMessages } from "react-intl";

export const scope = "components.CurrencyOperationCard";

export const historyMessages = defineMessages<HISTORY_OPERATION_TYPE>({
  deposit: {
    id: `${scope}.deposit`,
    defaultMessage: "Recibiste",
  },
  trade: {
    id: `${scope}.trade`,
    defaultMessage: "Cambiaste",
  },
  withdraw: {
    id: `${scope}.withdraw`,
    defaultMessage: "Enviaste",
  },
  referrer_payout: {
    id: `${scope}.referrer_payout`,
    defaultMessage: "Comision referidos",
  },
  interest_payment: {
    id: `${scope}.interest_payment`,
    defaultMessage: "Ganaste",
  },
  card_transactions: {
    id: `${scope}.card_transactions`,
    defaultMessage: "Tarjeteaste",
  },
  adjustment: {
    id: `${scope}.adjustments`,
    defaultMessage: "Ajustes",
  },
  reward: {
    id: `${scope}.reward`,
    defaultMessage: "Recompensa",
  },
  autoswap: {
    id: `${scope}.autoswap`,
    defaultMessage: "Autoswap",
  },
  payment: {
    id: `${scope}.payment`,
    defaultMessage: "Pago de servicio",
  },
  withholding: {
    id: `${scope}.withholding`,
    defaultMessage: "Retenciones",
  },
  withholdings_withholding: {
    id: `${scope}.withholding`,
    defaultMessage: "Retenciones",
  },
  dollarize: {
    id: `${scope}.dollarize`,
    defaultMessage: "Dolarizaciones",
  },
  merk_account_movement: {
    id: `${scope}.merk_account_movement`,
    defaultMessage: "Movimientos",
  },
  merk_order: {
    id: `${scope}.merk_order`,
    defaultMessage: "Orden",
  },
});

export const messages = defineMessages({
  statusInProgress: {
    id: `${scope}.statusInProgress`,
    defaultMessage: "Pendiente",
  },
  statusFailed: {
    id: `${scope}.statusFailed`,
    defaultMessage: "Fallido",
  },
  statusOk: {
    id: `${scope}.statusOk`,
    defaultMessage: "Finalizado",
  },
  statusWaitingAuthorization: {
    id: `${scope}.statusWaitingAuthorization`,
    defaultMessage: "Esperando autorización desde la app",
  },
  cardTransactionRejected: {
    id: `${scope}.cardTransactionRejected`,
    defaultMessage: "Pago rechazado",
  },
  defaultAdjustments: {
    id: `${scope}.defaultAdjustments`,
    defaultMessage: "Ajuste",
  },
  payOn: {
    id: `${scope}.payOn`,
    defaultMessage: "Pago el",
  },
  rejectedPay: {
    id: `${scope}.rejectedPay`,
    defaultMessage: "Pago fallido el",
  },
});
